<template>
  <Dialog @submit="onSubmit" :title="title " submitButtonText="Create Payment">
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner />
    </div>
    <form v-else @submit="onSubmit">
      <div class="form-group">
        <label for="currency">Currency</label>
        <select v-model="form.currencyId" id="currency" class="form-control">
          <option v-for="currency of currencies" :value="currency.id" :key="currency.id">
            {{currency.code}} - {{currency.name}}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="amount">Amount*</label>
        <input
          type="number"
          v-validate="'required|min_value:0.5'"
          id="amount"
          name="amount"
          class="form-control"
          :class="{'is-invalid': errors.has('amount')}"
          v-model="form.amount"
        >
        <small v-show="errors.has('amount')" class="invalid-feedback">
          {{ errors.first('amount') }}
        </small>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          class="form-control main-textarea"
          rows="3"
          v-model="form.description"
          id="description"
          name="description"
          placeholder="Optional"
        >
        </textarea>
      </div>
    </form>
  </Dialog>
</template>
<script>
import Dialog from '@/components/Dialog';
import Spinner from '@/components/Spinner';
import ModalMixin from '@/mixins/ModalMixin';
import CURRENCIES from '@/graphql/Currencies/Currencies.gql';
import CREATE_PAYMENT from '@/graphql/Payment/CreatePayment.gql';

export default {
  name: 'CreatePayment',
  components: { Dialog, Spinner },
  mixins: [ModalMixin],
  props: {
    id: String,
  },
  data() {
    return {
      errorMessage: {},
      currencies: [],
      showSpinner: false,
      form: {
        amount: 0,
        currencyId: 1,
        description: '',
      },
    };
  },
  computed: {
    title() {
      return `Card: **** **** **** ${this.$route.query.cardNumber}`;
    },
  },
  methods: {
    createPayment() {
      return this.$apollo.mutate({
        mutation: CREATE_PAYMENT,
        variables: {
          companyId: this.$route.params.id,
          payment: {
            ...this.form,
            amount: parseFloat(this.form.amount),
            currencyId: parseInt(this.form.currencyId),
            description: this.form.description,
            cardId: this.$route.query.cardId,
          },
        },
      });
    },
    async onSubmit() {
      try {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
          return;
        }
        this.showSpinner = true;
        await this.createPayment();
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Payment was created',
        });
        this.close();
      } catch (e) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: e.message,
        });
      }
      this.showSpinner = false;
    },
  },
  apollo: {
    currencies: {
      query: CURRENCIES,
      loadingKey: 'showSpinner',
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/modals/CreatePaymentModal.vue